import { Link } from "react-router-dom";
import { FaArrowRight, FaCalendarAlt } from "react-icons/fa";
import { motion } from "framer-motion";

const BlogSection = () => {
  const blogs = [
    {
      id: 1,
      title: "5 Things to Consider Before Building Your Dream Home",
      date: "15 June 2026",
      image: "/images/blogs/blog-1.jpg",
      slug: "things-to-consider-before-building-home",
    },
    {
      id: 2,
      title: "Why Professional Construction Planning Matters",
      date: "10 June 2026",
      image: "/images/blogs/blog-2.jpg",
      slug: "construction-planning-guide",
    },
    {
      id: 3,
      title: "Top Property Investment Trends in 2026",
      date: "05 June 2026",
      image: "/images/blogs/blog-3.jpg",
      slug: "property-investment-trends-2026",
    },
  ];

  return (
    <section className="py-24 bg-slate-50">
      <div className="container-custom">

        {/* Heading */}

        <div className="text-center max-w-3xl mx-auto mb-16">

          <span className="text-[#F59E0B] uppercase tracking-widest font-semibold">
            Latest Articles
          </span>

          <h2 className="text-4xl lg:text-5xl font-bold text-[#082B57] mt-4">
            Insights &
            <span className="text-[#F59E0B]"> Industry Updates</span>
          </h2>

          <p className="text-gray-600 mt-6 leading-8">
            Stay informed with expert insights, construction tips,
            property investment guidance and industry updates.
          </p>

        </div>

        {/* Blog Cards */}

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">

          {blogs.map((blog, index) => (
            <motion.div
              key={blog.id}
              initial={{
                opacity: 0,
                y: 40,
              }}
              whileInView={{
                opacity: 1,
                y: 0,
              }}
              transition={{
                duration: 0.5,
                delay: index * 0.1,
              }}
              viewport={{ once: true }}
              className="group bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500"
            >

              {/* Image */}

              <div className="overflow-hidden">
                <img
                  src={blog.image}
                  alt={blog.title}
                  className="w-full h-64 object-cover group-hover:scale-110 transition duration-700"
                />
              </div>

              {/* Content */}

              <div className="p-7">

                <div className="flex items-center gap-2 text-sm text-gray-500 mb-4">
                  <FaCalendarAlt />
                  <span>{blog.date}</span>
                </div>

                <h3 className="text-xl font-bold text-[#082B57] leading-8 min-h-[90px]">
                  {blog.title}
                </h3>

                <Link
                  to={`/${blog.slug}`}
                  className="inline-flex items-center gap-2 text-[#F59E0B] font-semibold mt-6"
                >
                  Read More

                  <FaArrowRight className="group-hover:translate-x-2 transition-transform duration-300" />
                </Link>

              </div>

            </motion.div>
          ))}

        </div>

        {/* Button */}

        <div className="text-center mt-14">

          <Link
            to="/blogs"
            className="inline-flex items-center gap-3 bg-[#082B57] hover:bg-[#061f3d] text-white px-8 py-4 rounded-xl font-semibold transition"
          >
            View All Blogs
            <FaArrowRight />
          </Link>

        </div>

      </div>
    </section>
  );
};

export default BlogSection;